/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IAchTransaction, IApiList } from '../../../types';
import { Ach } from './types';

const initialState: IApiList<IAchTransaction> | null = null;

export const achReducer: Reducer<IApiList<IAchTransaction> | null> = (state = initialState, action) => {
  switch (action.type) {
    case Ach.GET_TRANSACTIONS_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
